var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","right":"0","bottom":"5rem","cursor":"pointer"}},[_c('img',{staticStyle:{"width":"5rem"},attrs:{"src":_vm.logo,"alt":""},on:{"click":_vm.bottomSkip}})])
}
var staticRenderFns = []

export { render, staticRenderFns }